// extracted by mini-css-extract-plugin
module.exports = {"bg_resources":"Resources_bg_resources__xKf1J","bg":"Resources_bg__6VKFl"};